import { render, staticRenderFns } from "./arrivalReservation.vue?vue&type=template&id=03cc74eb&"
import script from "./arrivalReservation.vue?vue&type=script&lang=js&"
export * from "./arrivalReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports